import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bill-arrow",
  "use": "icon-bill-arrow-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol viewBox=\"0 0 14 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bill-arrow\">\n<path d=\"M12 3.5L7 8.5L2 3.5\" stroke=\"#013CF3\" stroke-width=\"1.4\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol